'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { SITE_URL } from '@/lib/constants';
// CL fix_7 §1 (레인 0b) — 유입 출처 캡처(kd_entry 미러) + page_views.entry_source.
import { captureEntryClient } from '@/lib/ad-entry/client';

export default function PageViewTracker() {
  const pathname = usePathname();

  // Service Worker 등록 (푸시 알림 전제조건 — 최초 1회)
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }
  }, []);

  useEffect(() => {
    if (!pathname) return;
    try {
      let vid = localStorage.getItem('kd_visitor_id');
      if (!vid) {
        vid = crypto.randomUUID();
        localStorage.setItem('kd_visitor_id', vid);
      }
      // 페이지마다 캡처(멱등) — 착지 첫 페이지에서 광고 파라미터를 sessionStorage 로 옮겨 둔다.
      let entrySource: string = 'organic';
      try { entrySource = captureEntryClient()?.src ?? 'organic'; } catch { /* 캡처 실패는 PV 를 막지 않는다 */ }
      // 광고 안내·구매 화면은 유입 표시(?from=, 예: bunyangline)를 경로에 붙여 남긴다 — 외부 게시글별 유입을 셀 수 있게(그 밖의 경로는 그대로).
      let pvPath = pathname;
      if (/^\/(advertise|ads)(\/|$)/.test(pathname)) {
        try {
          const f = new URLSearchParams(window.location.search).get('from');
          if (f && /^[a-z0-9_]{1,30}$/.test(f)) pvPath = `${pathname}?from=${f}`;
        } catch { /* 그대로 */ }
      }
      const body = JSON.stringify({ visitor_id: vid, path: pvPath, referrer: document.referrer || null, entry_source: entrySource });
      const sent = typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function'
        && navigator.sendBeacon('/api/analytics/pageview', new Blob([body], { type: 'application/json' }));
      if (!sent) {
        fetch('/api/analytics/pageview', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true,
        }).catch(() => {});
      }

      // GA4 SPA 페이지뷰 추적
      const w = window as any;
      if (typeof w.gtag === 'function') {
        w.gtag('event', 'page_view', {
          // S1: 토글은 제거했지만 kd_theme 값은 브라우저에 남아 있다 — 기존 선호 분포를 계속 수집
          theme_mode: (() => { try { return localStorage.getItem('kd_theme') || 'unset'; } catch { return 'unset'; } })(),
          page_path: pathname,
          page_location: `${SITE_URL}${pathname}`, // hc3 e(H5) — 도메인 리터럴 대신 SITE_URL 단일 출처(lib/constants 기본값과 동일 문자열)
        });
      }
    } catch {}
  }, [pathname]);

  return null;
}
